export default __webpack_public_path__ + "static/media/icon_user.d10e3008.svg";